import { h } from 'preact';
import { vendors } from '../../config/vendor';
import { Footer } from '@albelli/arc-3-react/lib/Footer';
import '@albelli/arc-3/lib/footer.css';
import { domainPrefix } from '../../config/domainPrefix';

const FooterPart = ({ storefrontConfig, vendor }) => {
    const vendorLinks = {};

    for (const vendor of Object.keys(vendors)) {
        vendorLinks[vendor] = `https://${domainPrefix}${vendor}`;
    }

    return <Footer storefrontConfig={storefrontConfig} vendor={vendor} vendorLinks={vendorLinks} />;
};

export default FooterPart;
